import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_page_title = _resolveComponent("page-title")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_date_pager = _resolveComponent("date-pager")!
  const _component_v_textarea = _resolveComponent("v-textarea")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_page_title, { value: "園日誌" }),
        _createVNode(_component_v_spacer),
        _createVNode(_component_v_btn, {
          color: "black",
          class: "mx-2",
          variant: "outlined"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_icon, { start: "" }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode("mdi-printer", -1)
              ]))]),
              _: 1
            }),
            _cache[12] || (_cache[12] = _createTextVNode(" 印刷 ", -1))
          ]),
          _: 1
        }),
        (_ctx.reportExists)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              _createVNode(_component_v_btn, {
                onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateReport('draft'))),
                color: "primary",
                class: "mx-2",
                variant: "outlined"
              }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode("下書き保存", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.updateReport('applied'))),
                color: "primary",
                class: "ml-2",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[14] || (_cache[14] = [
                  _createTextVNode("申請", -1)
                ]))]),
                _: 1
              })
            ], 64))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              _createVNode(_component_v_btn, {
                onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.createReport('draft'))),
                color: "primary",
                class: "mx-2",
                variant: "outlined"
              }, {
                default: _withCtx(() => [...(_cache[15] || (_cache[15] = [
                  _createTextVNode("下書き保存", -1)
                ]))]),
                _: 1
              }),
              _createVNode(_component_v_btn, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.createReport('applied'))),
                color: "primary",
                class: "ml-2",
                variant: "flat"
              }, {
                default: _withCtx(() => [...(_cache[16] || (_cache[16] = [
                  _createTextVNode("申請", -1)
                ]))]),
                _: 1
              })
            ], 64))
      ]),
      _: 1
    }),
    _createVNode(_component_v_row, null, {
      default: _withCtx(() => [
        _createVNode(_component_date_pager, {
          modelValue: _ctx.date,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.date) = $event)),
          class: "pt-4"
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }),
    _createElementVNode("div", null, _toDisplayString(_ctx.classDiaries), 1),
    _createVNode(_component_v_form, { ref: "form" }, {
      default: _withCtx(() => [
        _createVNode(_component_v_container, {
          fluid: "",
          class: "pt-10"
        }, {
          default: _withCtx(() => [
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[17] || (_cache[17] = _createElementVNode("div", { class: "pb-2" }, "本日のねらい", -1)),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.aim,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.aim) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[18] || (_cache[18] = _createElementVNode("div", { class: "pb-2" }, "主活動", -1)),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.activityAm,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.activityAm) = $event)),
                      variant: "outlined",
                      label: "午前"
                    }, null, 8, ["modelValue"]),
                    _createVNode(_component_v_text_field, {
                      modelValue: _ctx.activityPm,
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.activityPm) = $event)),
                      variant: "outlined",
                      label: "午後"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[19] || (_cache[19] = _createElementVNode("div", { class: "pb-2" }, "自由記録", -1)),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.comment,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.comment) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[20] || (_cache[20] = _createElementVNode("div", { class: "pb-2" }, "園行事 / 来訪者", -1)),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.event,
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.event) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_row, null, {
              default: _withCtx(() => [
                _createVNode(_component_v_col, { cols: "6" }, {
                  default: _withCtx(() => [
                    _cache[21] || (_cache[21] = _createElementVNode("div", { class: "pb-2" }, "欠席者等（理由）", -1)),
                    _createVNode(_component_v_textarea, {
                      modelValue: _ctx.absentee,
                      "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.absentee) = $event)),
                      variant: "outlined"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_v_col, { cols: "6" })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 512)
  ]))
}